import React from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/sections/HeroSection';
import { SocialProofSection } from '@/components/sections/SocialProofSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { LearnMoreSection } from '@/components/sections/LearnMoreSection';
import { DoubleClaimSection } from '@/components/sections/DoubleClaimSection';
import { HowItWorksSection } from '@/components/sections/HowItWorksSection';
import { WhyChooseUsSection } from '@/components/sections/WhyChooseUsSection';
import { FAQSection } from '@/components/sections/FAQSection';
import { CTASection } from '@/components/sections/CTASection';
import { SmartFAQSearch } from '@/components/ai/SmartFAQSearch';
import { Sparkles } from 'lucide-react';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <SocialProofSection />
        <ServicesSection />
        <LearnMoreSection />
        <DoubleClaimSection />
        
        {/* AI-Powered FAQ Section - Ask Us Anything - Moved higher for compliance */}
        <section id="ask-ai" className="py-20 lg:py-28 bg-muted/30">
          <div className="section-container">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-gold bg-gold/10 px-4 py-2 rounded-full mb-4">
                <Sparkles className="w-4 h-4" />
                AI-Powered FAQ
              </span>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                Ask Us Anything
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Our AI assistant can answer your questions instantly. Just type your question below.
              </p>
            </div>
            <SmartFAQSearch />
          </div>
        </section>
        
        <HowItWorksSection />
        <WhyChooseUsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
